<template>
  <v-dialog
    persistent
    v-model="dialogDeleteActive"
    :width="screenWidth + '%'"
  >
    <div class="container-dialog">
      <close-dialog-component @closeDialog="closeDialog" />
      <div class="display-flex align-items-center justify-content-center">
        <img
          width="90px"
          src="@/assets/icons/delete.png"
          alt=""
        >
      </div>
      <p class="text-title mon-bold">{{ texts.delete.textTitle }} {{ title }}</p>
      <div class="display-flex align-items-center justify-content-center">
        <p class="text-description mon-regular">{{ texts.delete.textDescription }}</p>
      </div>
      <div
        v-if="isResponsive"
        class="mt-9"
      >
        <v-btn
          class="button-primary mon-bold"
          elevation="0"
          @click="deleteItem"
          :loading="bLoading"
          style="width: 100%;"
        >
          {{ texts.delete.textButtonDelete }}
        </v-btn>
        <v-btn
          class="button-secondary mon-regular mt-5 mb-2"
          elevation="0"
          @click="closeDialog"
          style="width: 100%;"
        >
          {{ texts.delete.textButtonCancel }}
        </v-btn>
      </div>
      <div
        v-else
        class="display-flex align-items-center justify-content-center mt-9"
      >
        <v-btn
          class="button-cancel mon-regular"
          elevation="0"
          @click="closeDialog"
        >
          {{ texts.delete.textButtonCancel }}
        </v-btn>
        <v-btn
          class="button-delete mon-bold ml-5"
          elevation="0"
          @click="deleteItem"
          :loading="bLoading"
        >
          {{ texts.delete.textButtonDelete }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteComponent",
  data() {
    return {
      texts: "",
      title: "",
      api: "",
      texts: "",
      redirect: "",
      screenWidth: 0,
      bLoading: false,
      isResponsive: false,
    };
  },
  beforeMount() {
    this.texts = FILE.deletee[this.selectLanguage];
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize: function () {
      if (window.innerWidth >= 960) {
        this.screenWidth = 35;
      } else {
        this.screenWidth = 100;
      }

      if (window.innerWidth < 960) {
        this.isResponsive = true;
      } else {
        this.isResponsive = false;
      }
    },
    closeDialog: function () {
      this.$store.commit("setDialogDelete", {
        active: false,
        title: "",
        api: "",
        redirect: "",
      });
    },
    deleteItem: function () {
      this.bLoading = true;

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`,
        },
      };

      DB.delete(`${this.api}`, config)
        .then((response) => {
          this.bLoading = false;

          this.closeDialog();
          this.mixSuccess(response.data.message);
          if (this.redirect !== "") {
            this.$router.push(this.redirect);
          }
          this.$store.commit("refresher", true);
        })
        .catch((error) => {
          this.bLoading = false;

          this.closeDialog();
          this.mixError(error.response.data.message, error.response.status);
        });
    },
  },
  computed: {
    // return create contact dialog state
    dialogDeleteActive() {
      return this.$store.state.dialogDeleteActive;
    },
    selectLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    dialogDeleteActive() {
      if (this.dialogDeleteActive) {
        this.title = this.$store.state.dialogDeleteTitle;
        this.api = this.$store.state.dialogDeleteApi;
        this.redirect = this.$store.state.dialogDeleteRedirect;
        // this.texts = FILE.deletee[this.selectLanguage];
      }
    },
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.deletee[this.selectLanguage];
      }
    },
  },
};
</script>

<style scoped>
.container-dialog {
  width: 100%;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  opacity: 1;
  padding: 25px;
  position: relative;
}

.text-title {
  text-align: center;
  letter-spacing: 0px;
  color: #283c4d;
  opacity: 1;
  font-size: 25px;
}

.text-description {
  text-align: center;
  font-size: 16px;
  letter-spacing: 0px;
  color: #283c4d;
  opacity: 1;
  /* width: 240px; */
}

.button-cancel {
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #283c4d;
  border-radius: 10px;
  opacity: 1;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #283c4d;
  opacity: 1;
  height: 40px !important;
  text-transform: initial;
  padding-left: 35px !important;
  padding-right: 35px !important;
  background-color: #ffffff !important;
}

.button-delete {
  height: 40px !important;
  text-transform: initial;
  background: transparent linear-gradient(257deg, #ffc556 0%, #fffc81 100%) 0%
    0% no-repeat padding-box;
  border-radius: 10px;
  opacity: 1;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #283c4d;
  padding-left: 35px !important;
  padding-right: 35px !important;
}
</style>